

















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TramiteCambioDireccion from "@/models/tramite/cambio-direccion/cambio-direccion.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from '@/models/persona/persona.model';
import Beneficiario from '@/models/beneficiario/beneficiario.model';

@Component
export default class CambioDireccion extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  direccionesTableConfig!: BTableConfig<PersonaDireccion>;
  direccionPropuestaInit = new Direccion();
  direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);

  constructor() {
    super();
  }
  get personaId(){
    if(this.beneficiario && this.beneficiario.personaId)
    return this.beneficiario.personaId;

    if(this.solicitante && this.solicitante.id)
    return this.solicitante.id;

    return 0;
  }
  created() {
    // let props = [];
    // props.push(
    //   new TipoTramiteComponentProp("codigoHogar", "string"),
    //   new TipoTramiteComponentProp("cedula", "string")
    // );
       this.set(undefined);
    this.$emit("render", []);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteCambioDireccion)
        delete contenido.tramiteCambioDireccion;
      this.$emit("update:content", contenido);
    }
  }
  onSelect(selected: PersonaDireccion, oldSelected: PersonaDireccion) {
    this.direccionPropuesta = selected.direccion as Direccion;
    this.set(this.direccionPropuesta.id);
  }

  onAdd(added: PersonaDireccion) {
    this.direccionPropuesta = added.direccion as Direccion;
    this.set(this.direccionPropuesta.id);
  }

  onLoadTable(config: BTableConfig<PersonaDireccion>) {
    this.direccionesTableConfig = config;
  }
  quitDireccion() {
    this.direccionPropuesta = this.map<Direccion>(this.direccionPropuestaInit);
    this.direccionesTableConfig.selection.selected = null;
    this.set();
  }
  set(id?: number) {
    let contenido = this.content as any;
      let model = new TramiteCambioDireccion(id);
      if(this.beneficiario)
      model.personaId = this.beneficiario.personaId;
      if(contenido){
  contenido.tramiteCambioDireccion = model;
    this.$emit("update:content", contenido);
      }
    
  }

  hogar = new Hogar();
  repoHogar = new BaseRepository<Hogar>("hogar");
  @Watch("beneficiario", { immediate: true, deep:true })
  async onBeneficiarioChange(value: Beneficiario) {
    if (value && value.id) {
      this.hogar = (await this.repoHogar.one(`id=${value.hogarId}`)) || new Hogar();
    }else{
      this.hogar = new Hogar();
    }
  }
  //  @Watch("codigoHogar", { immediate: true })
  //  async onCodigoHogarChange(value: string) {
  //    if (value) {
  //      this.hogar = (await this.repoHogar.one(`codigo="${value}"`)) || new Hogar();
  //    }
  //  }
}
